import React, {Component} from "react";
import PersonDetail from "../../components/PersonDetail";
import {connect} from 'react-redux';


class MyProfile extends Component{

    render() {
        return (
            <div className="container-fluid People">
                <PersonDetail
                    person={ this.props.me? this.props.me.person : undefined }
                    canDownloadCredential={false}
                    canSendWelcome={false}
                />
            </div>
        );
    }
}

const mapStateToProps = ({api:{me}}) => ({me});

export default connect(mapStateToProps)(MyProfile);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MyProfile/index.js